import React from 'react';

export function CategorySelect({ categories, onSelect }) {
  return (
    <div>
      <h2 className="mb-1 text-lg font-semibold text-slate-900 dark:text-white">
        What do you want to ask about?
      </h2>
      <p className="mb-4 text-sm text-slate-600 dark:text-slate-300">
        Pick the issue — we&apos;ll walk you through a few quick questions.
      </p>
      <div className="grid gap-3 sm:grid-cols-2">
        {categories.map((c) => (
          <button
            key={c.key}
            type="button"
            onClick={() => onSelect(c.key)}
            className="rounded-xl border border-emerald-100 bg-white p-4 text-left transition hover:border-emerald-400 hover:shadow-sm dark:border-slate-700 dark:bg-slate-800 dark:hover:border-emerald-500"
          >
            <span className="block font-semibold text-slate-900 dark:text-white">{c.title}</span>
            <span className="mt-1 block text-sm text-slate-600 dark:text-slate-300">{c.description}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
